import React, {useState, useEffect, useRef} from "react";
import assets from "../assets/imgs";
import CalendarPopup from "./CalendarPopup";
import config from "../config/config";
const API_URL = config.API_URL;

function PerformanceAddBox({data, dataTitles, onClose, onSave, onDelete, 
  fixOrNot, boxTitle}){
  // console.log('input data is :' , data);
  // 예제 데이터 (data가 없을 때 기본값으로 사용)
  const exData = [
    { key : "_id", label: "", value : 1, type: "_id"},
    { key: "sales_date", label: "날짜", value: "2024-05-05", type: "date" },
    { key: "startup_name", label: "입주사명", value: "자동생성", type: "company" },
    { key: "client", label: "거래처", value: "기업", type: "select", options: ["기업", "개인", "기타"] },
    { key: "client_number", label: "거래처 사업자번호", value: "000-00-00000", type: "business-number" },
    { key: "item", label: "거래품목", value: "품목명", type: "text" },
    { key: "amount", label: "금액", value: "0", type: "money" },
    { key: "etc", label: "기타", value: "내용상세", type: "text" },
    { key: "file_name", label: "첨부파일", value: "000파일.pdf", type: "file", file_key: "https://www.naver.com"}
  ];

  const popupAnchorRef = useRef(null);

  const [isDatePickerOpen, setIsDatePickerOpen] = useState(null);

  const handleDatePickerOpen = (key, event) => {
    event.stopPropagation();
    popupAnchorRef.current = event.target; // 클릭된 DOM 저장
    setIsDatePickerOpen(key);
  };

  const [fixable, setFixable] = useState(!data || fixOrNot); // 수정하기 기능
  const [confirmType, setConfirmType] = useState(null);

  // data가 없으면 exData를 사용
  const mapData = data ?? dataTitles; //초기 입력용
  const [formData, setFormData] = useState({}); // 변경시 입력 및 저장시 이용 데이터(fileData 때문에 어쩔수 없이 이원화)

  const fileInputRef = useRef(null); // 파일 input 참조 생성

  useEffect(() => {
    const initialData = mapData.reduce((acc, field) => { 
      let value = field.value ?? "";
      // 날짜 필드일 경우 YYYY-MM-DD로 변환
      if (!field.value && field.type === "_id"){
        value = null;
      }
      if (field.value && field.type === "date") {
        // value가 "알 수 없음" 같은 비유효한 값인지 확인
        if (isNaN(new Date(value).getTime())) {
          value = null; // 날짜로 변환 불가능하면 null 설정
        } else {
          value = new Date(value).toISOString().split("T")[0];
        }
      }

      acc[field.key] = value;
      return acc;
    }, {});
    // console.log('initialData:', initialData);
    setFormData(initialData);
  }, [data, dataTitles]); // data가 변경될 때마다 실행

  // 입력값 변경 핸들러
  const handleChange = (key, value) => {
    setFormData({ ...formData, [key]: value });
  };

  // 모달 바깥 클릭 시 닫기
  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) onClose();
  };

  // const handleDatePickerOpen = (key) => {
  //   setIsDatePickerOpen((prev) => (prev === key ? null : key));
  // };

  const handleSave = async ()=>{
    await onSave(formData);
  }

  const handleDelete = async ()=>{
    await onDelete(formData["_id"]);
  }
  // console.log('mapData is : ' , mapData);
  // console.log('formData is : ' , formData);

  const handleDownlaod = async (fileKey, fileName) =>{
    try {
      const response = await fetch(`${API_URL}/api/file/download`, {
        method: "POST", // 보안상의 이유로 POST 사용
        headers: {
          "Content-Type": "application/json",
        },
        credentials: "include",
        body: JSON.stringify({ file_key: fileKey }),
      });
  
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
  
      const result = await response.json();
      if (!result.url) {
        throw new Error("파일 다운로드 URL이 없습니다.");
      }
  
      // 파일 다운로드 실행
      const link = document.createElement("a");
      link.href = result.url;
      link.setAttribute("download", fileName || "downloaded-file");
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
  
      console.log(" 파일 다운로드 완료:", result.url);
    } catch (error) {
      console.error("파일 다운로드 오류:", error);
      alert("파일 다운로드에 실패했습니다.");
    }
  };

  return(
    <div style={styles.overlay} onClick={handleOverlayClick}>
      <div style={styles.modal}>
        <div style={styles.xbox} onClick={onClose}><assets.icons.icon_x/></div>
        <div style={styles.headerLine}>
          <h2 className="font-body1-semibold">{boxTitle}</h2>
          <div style={styles.btnList}>
            {!data ? (
              <MainButton text ={'저장하기'} mainColorRedWhite={true} onClick={() => setConfirmType("save")}/>
            ): (
              <>
                {fixable ?(
                  <MainButton text ={'저장하기'} mainColorRedWhite={true} onClick={() => setConfirmType("save")}/>
                ):(
                  <MainButton text={'수정하기'} mainColorRedWhite={true} onClick={()=> setFixable(true)}/>
                )}
                <MainButton text={'삭제하기'} mainColorRedWhite={false} onClick ={() => setConfirmType("delete")}/>
              </>
            )}            
          </div>
        </div>
        
        <div style={styles.formContainer}>
          {mapData
            .filter(({key}) => key !== "_id")//_id 필터링
            .map(({ key, label, type, options, file_key, value }, index) => (
            <div key={index} style={styles.formGroup}>
              <label style={styles.label} className="font-body4-semibold">{label}</label>
              
              {fixable ? (
                (() =>{

                  switch(type){                    
                    case "text":
                      return (
                        <input
                          type="text"
                          value={formData[key] || ""}
                          onChange={(e) => handleChange(key, e.target.value)}
                          style={styles.formInput}
                        />
                      );
                    case "company":
                      
                      // console.log('data: ', !data, data ,'value: ', !value, value);
                      // console.log(formData[key], type);
                      return(
                        //분기1 새로 작성인데, value가 없을때 (ex. 관리자)-->작성 가능 (data - false /  value - false)
                        //분기1-2 새로 작성인데, value가 있을때 (ex. 스타트업) --> 수정불가(data - false /  value - true)
                        //분기2-1 수정인데, value가 없을때 (관리자가 수정할때) (data - true /  value - false)
                        //분기2-2 수정인데, valeu가 있을때 --> 수정 불가 (data - true /  value - true)
                        (!data && !value) ? (
                          <input
                            type="text"
                            value={formData[key] || ""}
                            onChange={(e) => handleChange(key, e.target.value)}
                            style={styles.formInput}
                          />
                        ) : (
                          <div style={styles.formInput}>{value?.name || formData[key]}</div>
                        )
                      );
                    case "money":
                      return (
                        <div style={styles.formInput}>
                          <input
                            type="text"
                            value={formData[key] ? Number(formData[key]).toLocaleString() : ""}
                            onChange={(e) => {
                              let rawValue = e.target.value.replace(/\D/g, ""); // 숫자만 허용

                              handleChange(key, rawValue);
                            }}
                            placeholder="1,000,000"
                            style={{...styles.formInput,
                              border: "none",
                              padding: "0",
                            }}
                          />
                          <span style={{ fontSize: "16px", color: "black" }}>원</span>
                        </div>                        
                      );
                    case "business-number":
                      return(
                        <input
                          type="text"
                          value={formData[key] || ""}
                          onChange={(e) => {
                            let rawValue = e.target.value.replace(/\D/g, ""); // 숫자만 허용
                            if (rawValue.length > 10) rawValue = rawValue.slice(0, 10); // 10자리 초과 입력 방지

                            // 사업자등록번호 형식 적용
                            let formattedValue = rawValue.replace(/(\d{3})(\d{2})(\d{0,5})/, (match, p1, p2, p3) => {
                              return p3 ? `${p1}-${p2}-${p3}` : p2 ? `${p1}-${p2}` : p1;
                            });

                            handleChange(key, formattedValue);
                          }}
                          placeholder="000-00-00000"
                          style={styles.formInput}
                          maxLength={12} // 최대 12자리 (숫자 10 + 하이픈 2개)
                        />
                      );
                    case "date":
                      return (
                        <div style={{...styles.formInput, position: "relative"}}>
                          <p>{formData[key]}</p>
                          <div style={{cursor: "pointer"}} onClick={(e) => 
                            handleDatePickerOpen(key, e)
                            }>
                            <assets.icons.icon_calendar_filled/>
                          </div>
                          {isDatePickerOpen === key && (
                            <CalendarPopup
                              selectedDate={formData[key]}
                              onSelect={(date) => handleChange(key, date)}
                              onClose={() => setIsDatePickerOpen(null)}
                              anchorRef={popupAnchorRef}
                            />
                          )}
                        </div>
                      );

                    case "select":
                      const titleMeta = dataTitles.find((item) => item.key === key);
                      const options = titleMeta?.options || [];
                      
                      if (!options || options.length === 0) {
                        return <p style={{ color: "red", fontWeight: "bold" }}>🚨 오류: 선택할 옵션이 없습니다.</p>;
                      }

                      return (
                        <select
                          value={formData[key] || ""}
                          onChange={(e) => handleChange(key, e.target.value)}
                          style={{...styles.formInput, cursor:"pointer"}}
                        >
                          <option value="" disabled>선택</option>
                          {options.map((option, i) => (
                            <option key={i} value={option}>
                              {option}
                            </option>
                          ))}
                        </select>
                      );

                      case "file":
                        return (<div style={styles.formInput}>
                          {/* 숨겨진 파일 입력 필드 */}
                          <input
                            type="file"
                            ref={fileInputRef}
                            style={{ display: "none" }}
                            onChange={(e) => {
                              if (e.target.files.length > 0) {
                                const file = e.target.files[0]; // 첫 번째 파일
                                const maxMegaBite = 10;
                                const maxSize = maxMegaBite * 1024 * 1024; //(10 MB)
                                if (file.size > maxSize) {
                                  alert(`파일 크기는 ${maxMegaBite}MB를 초과할 수 없습니다.`); // 사용자 알림
                                  return; // 파일 저장하지 않음
                                }

                                console.log(key, file.name);
                                setFormData((prevData) =>({
                                  ...prevData,
                                  [key]: file.name,  // 파일 이름 저장
                                  file_data: file,    // 실제 파일 객체 저장
                                }))
                                console.log(formData[key]);
                                console.log('file uploaded');
                              }
                            }}
                          />
                          <div style={styles.btnFile} 
                            onClick={() => {
                              fileInputRef.current.click();
                            }}
                            className="font-body4-semibold">파일 추가</div>
                          <assets.icons.icon_file/>
                          <span>{formData[key] !== "" ? formData[key]:  "선택된 파일 없음"}</span>
                        </div>);

                    default :
                      return <p style={{ color: "red", fontWeight: "bold" }}>🚨 지원되지 않는 입력 유형: {type}</p>;
                  }
                })()
              ) : (// 수정 불가능 상태
                (() =>{
                  switch(type){
                    case "money":
                      return (<div style={styles.formInput}>{formData[key] ? Number(formData[key]).toLocaleString(): ""} 원</div>);
                    case "file":
                      return (<div style={{...styles.formInput, cursor:"pointer"}} onClick={
                        () => handleDownlaod(file_key, value)
                      }>
                        <assets.icons.icon_file/>
                        <span>{formData[key] !== "" ? formData[key]:  "선택된 파일 없음"}</span>
                      </div>);
                    default:
                      return (<div style={styles.formInput}>{formData[key]}</div>);
                  }
                })()                
              )}
            </div>
          ))}
        </div>
      </div>

      {confirmType === "delete" && (
        <ConfirmBox
          head="정말 삭제하시겠습니까?"
          describe="삭제된 데이터는 복구할 수 없습니다."
          btn1Text="예"
          btn1Main={false}
          btn1Action={async () => {
            await handleDelete();
            setConfirmType(null); // 모달 닫기
          }}
          btn2Text="아니오"
          btn2Action={() => setConfirmType(null)}
          onClose={() => setConfirmType(null)}
        />
      )}

      {confirmType === "save" && (
        <ConfirmBox
          head="저장하시겠습니까?"
          describe="입력한 내용을 저장하시겠습니까?"
          btn1Text="저장"
          btn1Main={true}
          btn1Action={async () => {
            // onSave();
            await handleSave();
            setConfirmType(null);
          }}
          btn2Text="취소"
          btn2Action={() => setConfirmType(null)}
          onClose={() => setConfirmType(null)}
        />
      )}
    </div>
  );
}

function MainButton({text, mainColorRedWhite = true, onClick}){
  return(
    <div style={{...styles.btnMainStyle,
      backgroundColor: mainColorRedWhite ? "var(--primary-crimson_60)" : "white",
      color: mainColorRedWhite ? "white" : "var(--primary-crimson_60)",
      border: "1px solid var(--primary-crimson_60)"
    }}
      onClick={onClick}
    >
      {text}
    </div>
  );
}

function ConfirmBox({head, describe, 
  btn1Action, btn1Text, btn1Main, btn2Action, btn2Text,
  onClose}){

  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return(
    <div style={styles.overlay} onClick={handleOverlayClick}>
      <div style={styles.modalConfirm}>
        <div style={styles.headerLineConfirm}>
          <h2 className="font-body1-semibold">{head}</h2>
          <p className="font-body3-regular">{describe}</p>
        </div>        
        <div style={styles.btnListConfirm}>
          <ConfirmButton text={btn1Text} mainRed={btn1Main} onClick={btn1Action}/>
          <ConfirmButton text={btn2Text} mainRed={!btn1Main} onClick={btn2Action}/>
        </div>
      </div>
    </div>
  );
}

function ConfirmButton({text, onClick, mainRed}){
  return(
    <div style={{
      ...styles.btnConfrim,
      backgroundColor: mainRed ? "var(--primary-crimson_60)" : "var(--grayscale_40)",
      color: mainRed ? "white" : "var(--grayscale_60)"
    }} onClick={onClick}>
      {text}
    </div>
  )
}

const styles ={
  overlay: {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    backgroundColor: "rgba(0, 0, 0, 0.5)", // 반투명 배경
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 1000,
  },
  modal: {
    backgroundColor: "white",
    borderRadius: "25px",
    padding: "72px 32px 32px 32px",
    width: "850px",
    boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
    position: "relative",
  },
  
  headerLine:{
    display: "flex",
    alignItems : "center",
    justifyContent: "space-between",
    marginBottom: "20px",
    padding: "0px 6px",
  },
  xbox: {
    cursor: "pointer",
    position: "absolute",
    right: "32px",
    top: "32px",
  },
  btnList: {
    display:"flex",
    gap: "16px",
  },
  btnMainStyle:{
    borderRadius: "8px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "100px",
    height: "45px",
    cursor: "pointer",
  },
  formGroup: {
    display: "flex",
  },
  label:{
    width: "114px",
    height: "44px",
    backgroundColor: "var(--grayscale_20)",
    color: "var(--grayscale_80)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  formInput: {
    display: "flex",
    gap: "8px",
    alignItems: "center",
    padding: "0px 16px",
    border: "none",
    outline: "none",
    borderBottom: "1px solid var(--grayscale_20)",
    flex: "1",
  },
  formInputEdit:{

  },
  modalConfirm:{
    padding: "20px",
    borderRadius: "12px",
    backgroundColor: "white",
  },
  headerLineConfirm:{
    display:"flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems : "center",
    gap: "12px",
    padding: "45px 0px"
  },
  btnListConfirm :{
    display:"flex", gap:"8px"
  },
  btnConfrim:{
    borderRadius: "4px",
    height: "60px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    cursor: "pointer",
    minWidth: "165px",
    flex:"1"
  },
  btnFile:{
    display:"flex",
    alignItems: "center",
    justifyContent: "center",
    width:"72px",
    height:"32px",
    color: "white",
    backgroundColor: "var(--grayscale-cool_80)",
    borderRadius: "4px",
    cursor:"pointer"
  }
}

export {PerformanceAddBox, ConfirmBox};